/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardCreateTournamentCategory,
  DashboardCreateTournamentCategoryGroup,
  DashboardDeleteTournament,
  DashboardReorderTournamentCategories,
  DashboardTournamentApproval,
  DashboardTournamentApprovalUpdate,
  DashboardTournamentCalendar,
  DashboardTournamentCategoriesControllerCreate400,
  DashboardTournamentCategoriesControllerCreate401,
  DashboardTournamentCategoriesControllerCreate429,
  DashboardTournamentCategoriesControllerDetail400,
  DashboardTournamentCategoriesControllerDetail401,
  DashboardTournamentCategoriesControllerDetail404,
  DashboardTournamentCategoriesControllerDetail429,
  DashboardTournamentCategoriesControllerDuplicate400,
  DashboardTournamentCategoriesControllerDuplicate401,
  DashboardTournamentCategoriesControllerDuplicate404,
  DashboardTournamentCategoriesControllerDuplicate429,
  DashboardTournamentCategoriesControllerList400,
  DashboardTournamentCategoriesControllerList401,
  DashboardTournamentCategoriesControllerList429,
  DashboardTournamentCategoriesControllerListParams,
  DashboardTournamentCategoriesControllerRefs400,
  DashboardTournamentCategoriesControllerRefs401,
  DashboardTournamentCategoriesControllerRefs429,
  DashboardTournamentCategoriesControllerRefsParams,
  DashboardTournamentCategoriesControllerRemove400,
  DashboardTournamentCategoriesControllerRemove401,
  DashboardTournamentCategoriesControllerRemove404,
  DashboardTournamentCategoriesControllerRemove409,
  DashboardTournamentCategoriesControllerRemove429,
  DashboardTournamentCategoriesControllerReorder400,
  DashboardTournamentCategoriesControllerReorder401,
  DashboardTournamentCategoriesControllerReorder429,
  DashboardTournamentCategoriesControllerSearch400,
  DashboardTournamentCategoriesControllerSearch401,
  DashboardTournamentCategoriesControllerSearch429,
  DashboardTournamentCategoriesControllerSearchParams,
  DashboardTournamentCategoriesControllerUpdate400,
  DashboardTournamentCategoriesControllerUpdate401,
  DashboardTournamentCategoriesControllerUpdate404,
  DashboardTournamentCategoriesControllerUpdate409,
  DashboardTournamentCategoriesControllerUpdate429,
  DashboardTournamentCategoryDetail,
  DashboardTournamentCategoryGroupDetail,
  DashboardTournamentCategoryGroupList,
  DashboardTournamentCategoryGroupsControllerCreate400,
  DashboardTournamentCategoryGroupsControllerCreate401,
  DashboardTournamentCategoryGroupsControllerCreate429,
  DashboardTournamentCategoryGroupsControllerDetail400,
  DashboardTournamentCategoryGroupsControllerDetail401,
  DashboardTournamentCategoryGroupsControllerDetail404,
  DashboardTournamentCategoryGroupsControllerDetail429,
  DashboardTournamentCategoryGroupsControllerList400,
  DashboardTournamentCategoryGroupsControllerList401,
  DashboardTournamentCategoryGroupsControllerList429,
  DashboardTournamentCategoryGroupsControllerListCategories400,
  DashboardTournamentCategoryGroupsControllerListCategories401,
  DashboardTournamentCategoryGroupsControllerListCategories403,
  DashboardTournamentCategoryGroupsControllerListCategories404,
  DashboardTournamentCategoryGroupsControllerListCategories429,
  DashboardTournamentCategoryGroupsControllerListCategoriesParams,
  DashboardTournamentCategoryGroupsControllerListParams,
  DashboardTournamentCategoryGroupsControllerRemove400,
  DashboardTournamentCategoryGroupsControllerRemove401,
  DashboardTournamentCategoryGroupsControllerRemove404,
  DashboardTournamentCategoryGroupsControllerRemove429,
  DashboardTournamentCategoryGroupsControllerUpdate400,
  DashboardTournamentCategoryGroupsControllerUpdate401,
  DashboardTournamentCategoryGroupsControllerUpdate404,
  DashboardTournamentCategoryGroupsControllerUpdate429,
  DashboardTournamentCategoryList,
  DashboardTournamentCategoryListItem,
  DashboardTournamentCategoryRef,
  DashboardTournamentCategorySearch,
  DashboardTournamentContext,
  DashboardTournamentCopy,
  DashboardTournamentList,
  DashboardTournamentOrganizerSearchResult,
  DashboardTournamentOverview,
  DashboardTournamentRef,
  DashboardTournamentStats,
  DashboardTournamentsControllerCalendar400,
  DashboardTournamentsControllerCalendar401,
  DashboardTournamentsControllerCalendar429,
  DashboardTournamentsControllerCalendarParams,
  DashboardTournamentsControllerContext400,
  DashboardTournamentsControllerContext401,
  DashboardTournamentsControllerContext429,
  DashboardTournamentsControllerCopy400,
  DashboardTournamentsControllerCopy401,
  DashboardTournamentsControllerCopy404,
  DashboardTournamentsControllerCopy429,
  DashboardTournamentsControllerExport400,
  DashboardTournamentsControllerExport401,
  DashboardTournamentsControllerExport413,
  DashboardTournamentsControllerExport429,
  DashboardTournamentsControllerExportParams,
  DashboardTournamentsControllerList400,
  DashboardTournamentsControllerList401,
  DashboardTournamentsControllerList429,
  DashboardTournamentsControllerListParams,
  DashboardTournamentsControllerOverview400,
  DashboardTournamentsControllerOverview401,
  DashboardTournamentsControllerOverview429,
  DashboardTournamentsControllerRefs400,
  DashboardTournamentsControllerRefs401,
  DashboardTournamentsControllerRefs429,
  DashboardTournamentsControllerRefsParams,
  DashboardTournamentsControllerRemove400,
  DashboardTournamentsControllerRemove401,
  DashboardTournamentsControllerRemove403,
  DashboardTournamentsControllerRemove404,
  DashboardTournamentsControllerRemove429,
  DashboardTournamentsControllerResultsContext400,
  DashboardTournamentsControllerResultsContext401,
  DashboardTournamentsControllerResultsContext429,
  DashboardTournamentsControllerSearchOrganizers400,
  DashboardTournamentsControllerSearchOrganizers401,
  DashboardTournamentsControllerSearchOrganizers429,
  DashboardTournamentsControllerSearchOrganizersParams,
  DashboardTournamentsControllerStats400,
  DashboardTournamentsControllerStats401,
  DashboardTournamentsControllerStats429,
  DashboardTournamentsControllerStatsParams,
  DashboardTournamentsControllerTransactionsContext400,
  DashboardTournamentsControllerTransactionsContext401,
  DashboardTournamentsControllerTransactionsContext429,
  DashboardTournamentsControllerUpdateApprovalStatus400,
  DashboardTournamentsControllerUpdateApprovalStatus401,
  DashboardTournamentsControllerUpdateApprovalStatus404,
  DashboardTournamentsControllerUpdateApprovalStatus429,
  DashboardUpdateTournamentCategory,
  DashboardUpdateTournamentCategoryGroup,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * PII-free tournament, owning league/platform/federation, sport, dates, state, and location context. Organizer and referee identities are intentionally omitted. The any-of point guard admits section-only grants so pages can render identity/breadcrumbs without depending on unrelated TOURNAMENT:READ; section routes still enforce their own capability.
 * @summary Get shared tournament page context (dashboard)
 */
export const dashboardTournamentsControllerContext = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentContext>(
    { url: `/api/dashboard/v1/tournaments/${id}/context`, method: "GET", signal },
    options
  );
};

export const getDashboardTournamentsControllerContextQueryKey = (id: string) => {
  return [`/api/dashboard/v1/tournaments/${id}/context`] as const;
};

export const getDashboardTournamentsControllerContextQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerContext400
    | DashboardTournamentsControllerContext401
    | DashboardTournamentsControllerContext429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardTournamentsControllerContextQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>
  > = ({ signal }) => dashboardTournamentsControllerContext(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentsControllerContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>
>;
export type DashboardTournamentsControllerContextQueryError = ErrorType<
  | DashboardTournamentsControllerContext400
  | DashboardTournamentsControllerContext401
  | DashboardTournamentsControllerContext429
>;

export function useDashboardTournamentsControllerContext<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerContext400
    | DashboardTournamentsControllerContext401
    | DashboardTournamentsControllerContext429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerContext<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerContext400
    | DashboardTournamentsControllerContext401
    | DashboardTournamentsControllerContext429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerContext<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerContext400
    | DashboardTournamentsControllerContext401
    | DashboardTournamentsControllerContext429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get shared tournament page context (dashboard)
 */

export function useDashboardTournamentsControllerContext<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerContext400
    | DashboardTournamentsControllerContext401
    | DashboardTournamentsControllerContext429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerContext>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentsControllerContextQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * PII-minimal tournament identity and breadcrumb context for the Results page. Strictly requires TOURNAMENT_STANDINGS:READ at the path tournament; another tournament-section permission does not authorize this route.
 * @summary Get tournament results page context (dashboard)
 */
export const dashboardTournamentsControllerResultsContext = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentContext>(
    { url: `/api/dashboard/v1/tournaments/${id}/results/context`, method: "GET", signal },
    options
  );
};

export const getDashboardTournamentsControllerResultsContextQueryKey = (id: string) => {
  return [`/api/dashboard/v1/tournaments/${id}/results/context`] as const;
};

export const getDashboardTournamentsControllerResultsContextQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerResultsContext400
    | DashboardTournamentsControllerResultsContext401
    | DashboardTournamentsControllerResultsContext429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardTournamentsControllerResultsContextQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>
  > = ({ signal }) => dashboardTournamentsControllerResultsContext(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentsControllerResultsContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>
>;
export type DashboardTournamentsControllerResultsContextQueryError = ErrorType<
  | DashboardTournamentsControllerResultsContext400
  | DashboardTournamentsControllerResultsContext401
  | DashboardTournamentsControllerResultsContext429
>;

export function useDashboardTournamentsControllerResultsContext<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerResultsContext400
    | DashboardTournamentsControllerResultsContext401
    | DashboardTournamentsControllerResultsContext429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerResultsContext<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerResultsContext400
    | DashboardTournamentsControllerResultsContext401
    | DashboardTournamentsControllerResultsContext429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerResultsContext<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerResultsContext400
    | DashboardTournamentsControllerResultsContext401
    | DashboardTournamentsControllerResultsContext429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get tournament results page context (dashboard)
 */

export function useDashboardTournamentsControllerResultsContext<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerResultsContext400
    | DashboardTournamentsControllerResultsContext401
    | DashboardTournamentsControllerResultsContext429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerResultsContext>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentsControllerResultsContextQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * PII-minimal tournament identity and breadcrumb context for the Transactions page. Strictly requires an ORG_FINANCE:READ, PLATFORM_FINANCE:READ, or LEAGUE_FINANCE:READ grant reaching the path tournament; non-finance tournament permissions do not authorize this route.
 * @summary Get tournament transactions page context (dashboard)
 */
export const dashboardTournamentsControllerTransactionsContext = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentContext>(
    { url: `/api/dashboard/v1/tournaments/${id}/transactions/context`, method: "GET", signal },
    options
  );
};

export const getDashboardTournamentsControllerTransactionsContextQueryKey = (id: string) => {
  return [`/api/dashboard/v1/tournaments/${id}/transactions/context`] as const;
};

export const getDashboardTournamentsControllerTransactionsContextQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerTransactionsContext400
    | DashboardTournamentsControllerTransactionsContext401
    | DashboardTournamentsControllerTransactionsContext429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardTournamentsControllerTransactionsContextQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>
  > = ({ signal }) => dashboardTournamentsControllerTransactionsContext(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentsControllerTransactionsContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>
>;
export type DashboardTournamentsControllerTransactionsContextQueryError = ErrorType<
  | DashboardTournamentsControllerTransactionsContext400
  | DashboardTournamentsControllerTransactionsContext401
  | DashboardTournamentsControllerTransactionsContext429
>;

export function useDashboardTournamentsControllerTransactionsContext<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerTransactionsContext400
    | DashboardTournamentsControllerTransactionsContext401
    | DashboardTournamentsControllerTransactionsContext429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerTransactionsContext<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerTransactionsContext400
    | DashboardTournamentsControllerTransactionsContext401
    | DashboardTournamentsControllerTransactionsContext429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerTransactionsContext<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerTransactionsContext400
    | DashboardTournamentsControllerTransactionsContext401
    | DashboardTournamentsControllerTransactionsContext429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get tournament transactions page context (dashboard)
 */

export function useDashboardTournamentsControllerTransactionsContext<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>,
  TError = ErrorType<
    | DashboardTournamentsControllerTransactionsContext400
    | DashboardTournamentsControllerTransactionsContext401
    | DashboardTournamentsControllerTransactionsContext429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerTransactionsContext>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentsControllerTransactionsContextQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Header data for TournamentOverviewPage. Returns public ids and rendered scalars plus one deprecated tournament internalId used only for legacy public-client and manager links. No other numeric entity ids, contact fields, payment details, demographic aggregates, fact sheets, or legacy manager logs.
 * @summary Get tournament overview header (dashboard)
 */
export const dashboardTournamentsControllerOverview = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentOverview>(
    { url: `/api/dashboard/v1/tournaments/${id}/overview`, method: "GET", signal },
    options
  );
};

export const getDashboardTournamentsControllerOverviewQueryKey = (id: string) => {
  return [`/api/dashboard/v1/tournaments/${id}/overview`] as const;
};

export const getDashboardTournamentsControllerOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>,
  TError = ErrorType<
    | DashboardTournamentsControllerOverview400
    | DashboardTournamentsControllerOverview401
    | DashboardTournamentsControllerOverview429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardTournamentsControllerOverviewQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>
  > = ({ signal }) => dashboardTournamentsControllerOverview(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentsControllerOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>
>;
export type DashboardTournamentsControllerOverviewQueryError = ErrorType<
  | DashboardTournamentsControllerOverview400
  | DashboardTournamentsControllerOverview401
  | DashboardTournamentsControllerOverview429
>;

export function useDashboardTournamentsControllerOverview<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>,
  TError = ErrorType<
    | DashboardTournamentsControllerOverview400
    | DashboardTournamentsControllerOverview401
    | DashboardTournamentsControllerOverview429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerOverview<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>,
  TError = ErrorType<
    | DashboardTournamentsControllerOverview400
    | DashboardTournamentsControllerOverview401
    | DashboardTournamentsControllerOverview429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerOverview<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>,
  TError = ErrorType<
    | DashboardTournamentsControllerOverview400
    | DashboardTournamentsControllerOverview401
    | DashboardTournamentsControllerOverview429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get tournament overview header (dashboard)
 */

export function useDashboardTournamentsControllerOverview<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>,
  TError = ErrorType<
    | DashboardTournamentsControllerOverview400
    | DashboardTournamentsControllerOverview401
    | DashboardTournamentsControllerOverview429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerOverview>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentsControllerOverviewQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Paginated tournament list scoped to the caller: the `TOURNAMENT:READ` RBAC capability universe (applied through the tournament’s bound league, incl. league-level grants). `platformIds` and `federationIds` are pure filters applied together (AND); the platform filter reads the authoritative league platform attribution. The league filter is authoritative: when `leagueIds` is present the platform / federation filters are ignored, and authorization narrows the requested league set instead of 403ing. Requesting an out-of-scope id yields a narrowed (possibly empty) page, never a 403. Filters: keyword, platform / federation / league / sport / team / club / category / organizer ids, League Setup season / region / level / custom tag ids (`sea_…` / `reg_…` / `lvl_…` / `tag_…`, OR-within / AND-across), ISO country codes, approval status, lifecycle bucket, start/end/created date ranges, activity-window overlap. Each row carries identity, dates, geo, status, and the related refs (sport / league / platform / federation).
 * @summary List tournaments (dashboard)
 */
export const dashboardTournamentsControllerList = (
  params?: DashboardTournamentsControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentList>(
    { url: `/api/dashboard/v1/tournaments`, method: "GET", params, signal },
    options
  );
};

export const getDashboardTournamentsControllerListQueryKey = (
  params?: DashboardTournamentsControllerListParams
) => {
  return [`/api/dashboard/v1/tournaments`, ...(params ? [params] : [])] as const;
};

export const getDashboardTournamentsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerList>>,
  TError = ErrorType<
    | DashboardTournamentsControllerList400
    | DashboardTournamentsControllerList401
    | DashboardTournamentsControllerList429
  >,
>(
  params?: DashboardTournamentsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTournamentsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardTournamentsControllerListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardTournamentsControllerList>>> = ({
    signal,
  }) => dashboardTournamentsControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentsControllerList>>
>;
export type DashboardTournamentsControllerListQueryError = ErrorType<
  | DashboardTournamentsControllerList400
  | DashboardTournamentsControllerList401
  | DashboardTournamentsControllerList429
>;

export function useDashboardTournamentsControllerList<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerList>>,
  TError = ErrorType<
    | DashboardTournamentsControllerList400
    | DashboardTournamentsControllerList401
    | DashboardTournamentsControllerList429
  >,
>(
  params: undefined | DashboardTournamentsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTournamentsControllerList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerList<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerList>>,
  TError = ErrorType<
    | DashboardTournamentsControllerList400
    | DashboardTournamentsControllerList401
    | DashboardTournamentsControllerList429
  >,
>(
  params?: DashboardTournamentsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTournamentsControllerList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerList<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerList>>,
  TError = ErrorType<
    | DashboardTournamentsControllerList400
    | DashboardTournamentsControllerList401
    | DashboardTournamentsControllerList429
  >,
>(
  params?: DashboardTournamentsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTournamentsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List tournaments (dashboard)
 */

export function useDashboardTournamentsControllerList<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerList>>,
  TError = ErrorType<
    | DashboardTournamentsControllerList400
    | DashboardTournamentsControllerList401
    | DashboardTournamentsControllerList429
  >,
>(
  params?: DashboardTournamentsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTournamentsControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentsControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Batch lookup of the slim `DashboardTournamentRef` shape (`id`, `title`, `logo`, `startDate`, `endDate`) for a known set of tournament publicIds (`trn_…`). Used to rehydrate the Tournament Matches page header, breadcrumb chips, and autocomplete labels from saved client state. Response order is not guaranteed; ids the caller cannot see (missing or out-of-scope) are silently omitted so existence does not leak.
 * @summary Resolve tournament refs by publicId (dashboard)
 */
export const dashboardTournamentsControllerRefs = (
  params: DashboardTournamentsControllerRefsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentRef[]>(
    { url: `/api/dashboard/v1/tournaments/refs`, method: "GET", params, signal },
    options
  );
};

export const getDashboardTournamentsControllerRefsQueryKey = (
  params: DashboardTournamentsControllerRefsParams
) => {
  return [`/api/dashboard/v1/tournaments/refs`, ...(params ? [params] : [])] as const;
};

export const getDashboardTournamentsControllerRefsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>,
  TError = ErrorType<
    | DashboardTournamentsControllerRefs400
    | DashboardTournamentsControllerRefs401
    | DashboardTournamentsControllerRefs429
  >,
>(
  params: DashboardTournamentsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardTournamentsControllerRefsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>> = ({
    signal,
  }) => dashboardTournamentsControllerRefs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentsControllerRefsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>
>;
export type DashboardTournamentsControllerRefsQueryError = ErrorType<
  | DashboardTournamentsControllerRefs400
  | DashboardTournamentsControllerRefs401
  | DashboardTournamentsControllerRefs429
>;

export function useDashboardTournamentsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>,
  TError = ErrorType<
    | DashboardTournamentsControllerRefs400
    | DashboardTournamentsControllerRefs401
    | DashboardTournamentsControllerRefs429
  >,
>(
  params: DashboardTournamentsControllerRefsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>,
  TError = ErrorType<
    | DashboardTournamentsControllerRefs400
    | DashboardTournamentsControllerRefs401
    | DashboardTournamentsControllerRefs429
  >,
>(
  params: DashboardTournamentsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>,
  TError = ErrorType<
    | DashboardTournamentsControllerRefs400
    | DashboardTournamentsControllerRefs401
    | DashboardTournamentsControllerRefs429
  >,
>(
  params: DashboardTournamentsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Resolve tournament refs by publicId (dashboard)
 */

export function useDashboardTournamentsControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>,
  TError = ErrorType<
    | DashboardTournamentsControllerRefs400
    | DashboardTournamentsControllerRefs401
    | DashboardTournamentsControllerRefs429
  >,
>(
  params: DashboardTournamentsControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardTournamentsControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentsControllerRefsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Paginated, autocomplete-friendly search over the users that actually organize tournaments within the supplied scope. Returns the shared dashboard user-ref shape (`id`, `name`, `surname`, `avatar`, `email`) wrapped in the standard pagination envelope so the FE can drive an infinite-scroll dropdown. Unlike `GET /users/search`, this lists only distinct organizers of tournaments matching the selected platform / federation / league filters (precedence: league > federation > platform), and is scoped identically to the tournament list — a caller cannot surface organizers of tournaments they cannot see.
 * @summary Search tournament organizers (dashboard)
 */
export const dashboardTournamentsControllerSearchOrganizers = (
  params?: DashboardTournamentsControllerSearchOrganizersParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentOrganizerSearchResult>(
    { url: `/api/dashboard/v1/tournaments/organizers/search`, method: "GET", params, signal },
    options
  );
};

export const getDashboardTournamentsControllerSearchOrganizersQueryKey = (
  params?: DashboardTournamentsControllerSearchOrganizersParams
) => {
  return [`/api/dashboard/v1/tournaments/organizers/search`, ...(params ? [params] : [])] as const;
};

export const getDashboardTournamentsControllerSearchOrganizersQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>,
  TError = ErrorType<
    | DashboardTournamentsControllerSearchOrganizers400
    | DashboardTournamentsControllerSearchOrganizers401
    | DashboardTournamentsControllerSearchOrganizers429
  >,
>(
  params?: DashboardTournamentsControllerSearchOrganizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardTournamentsControllerSearchOrganizersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>
  > = ({ signal }) =>
    dashboardTournamentsControllerSearchOrganizers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentsControllerSearchOrganizersQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>
>;
export type DashboardTournamentsControllerSearchOrganizersQueryError = ErrorType<
  | DashboardTournamentsControllerSearchOrganizers400
  | DashboardTournamentsControllerSearchOrganizers401
  | DashboardTournamentsControllerSearchOrganizers429
>;

export function useDashboardTournamentsControllerSearchOrganizers<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>,
  TError = ErrorType<
    | DashboardTournamentsControllerSearchOrganizers400
    | DashboardTournamentsControllerSearchOrganizers401
    | DashboardTournamentsControllerSearchOrganizers429
  >,
>(
  params: undefined | DashboardTournamentsControllerSearchOrganizersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerSearchOrganizers<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>,
  TError = ErrorType<
    | DashboardTournamentsControllerSearchOrganizers400
    | DashboardTournamentsControllerSearchOrganizers401
    | DashboardTournamentsControllerSearchOrganizers429
  >,
>(
  params?: DashboardTournamentsControllerSearchOrganizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerSearchOrganizers<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>,
  TError = ErrorType<
    | DashboardTournamentsControllerSearchOrganizers400
    | DashboardTournamentsControllerSearchOrganizers401
    | DashboardTournamentsControllerSearchOrganizers429
  >,
>(
  params?: DashboardTournamentsControllerSearchOrganizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search tournament organizers (dashboard)
 */

export function useDashboardTournamentsControllerSearchOrganizers<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>,
  TError = ErrorType<
    | DashboardTournamentsControllerSearchOrganizers400
    | DashboardTournamentsControllerSearchOrganizers401
    | DashboardTournamentsControllerSearchOrganizers429
  >,
>(
  params?: DashboardTournamentsControllerSearchOrganizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerSearchOrganizers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentsControllerSearchOrganizersQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Aggregate counts for the dashboard tournaments page. Three orthogonal dimensions: total / lifecycle bucket (inProgress, upcoming, completed) / approval workflow (approved, pending, declined). Accepts the same filter surface as the list endpoint (minus pagination + ordering); buckets do not partition.
 * @summary Tournament list stats (dashboard)
 */
export const dashboardTournamentsControllerStats = (
  params?: DashboardTournamentsControllerStatsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentStats>(
    { url: `/api/dashboard/v1/tournaments/stats`, method: "GET", params, signal },
    options
  );
};

export const getDashboardTournamentsControllerStatsQueryKey = (
  params?: DashboardTournamentsControllerStatsParams
) => {
  return [`/api/dashboard/v1/tournaments/stats`, ...(params ? [params] : [])] as const;
};

export const getDashboardTournamentsControllerStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>,
  TError = ErrorType<
    | DashboardTournamentsControllerStats400
    | DashboardTournamentsControllerStats401
    | DashboardTournamentsControllerStats429
  >,
>(
  params?: DashboardTournamentsControllerStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardTournamentsControllerStatsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>> = ({
    signal,
  }) => dashboardTournamentsControllerStats(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentsControllerStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>
>;
export type DashboardTournamentsControllerStatsQueryError = ErrorType<
  | DashboardTournamentsControllerStats400
  | DashboardTournamentsControllerStats401
  | DashboardTournamentsControllerStats429
>;

export function useDashboardTournamentsControllerStats<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>,
  TError = ErrorType<
    | DashboardTournamentsControllerStats400
    | DashboardTournamentsControllerStats401
    | DashboardTournamentsControllerStats429
  >,
>(
  params: undefined | DashboardTournamentsControllerStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerStats<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>,
  TError = ErrorType<
    | DashboardTournamentsControllerStats400
    | DashboardTournamentsControllerStats401
    | DashboardTournamentsControllerStats429
  >,
>(
  params?: DashboardTournamentsControllerStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerStats<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>,
  TError = ErrorType<
    | DashboardTournamentsControllerStats400
    | DashboardTournamentsControllerStats401
    | DashboardTournamentsControllerStats429
  >,
>(
  params?: DashboardTournamentsControllerStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Tournament list stats (dashboard)
 */

export function useDashboardTournamentsControllerStats<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>,
  TError = ErrorType<
    | DashboardTournamentsControllerStats400
    | DashboardTournamentsControllerStats401
    | DashboardTournamentsControllerStats429
  >,
>(
  params?: DashboardTournamentsControllerStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerStats>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentsControllerStatsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Calendar view of the dashboard tournaments page. Same filter surface as `/stats` plus the window (`from`, `to`, optional IANA `tz`). Span is capped at 42 days server-side; returns one bucket per day in `[from, to]` plus `nearestPastDate` / `nearestFutureDate` probes for the jump-arrows.
 * @summary Tournament calendar (dashboard)
 */
export const dashboardTournamentsControllerCalendar = (
  params: DashboardTournamentsControllerCalendarParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentCalendar>(
    { url: `/api/dashboard/v1/tournaments/calendar`, method: "GET", params, signal },
    options
  );
};

export const getDashboardTournamentsControllerCalendarQueryKey = (
  params: DashboardTournamentsControllerCalendarParams
) => {
  return [`/api/dashboard/v1/tournaments/calendar`, ...(params ? [params] : [])] as const;
};

export const getDashboardTournamentsControllerCalendarQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>,
  TError = ErrorType<
    | DashboardTournamentsControllerCalendar400
    | DashboardTournamentsControllerCalendar401
    | DashboardTournamentsControllerCalendar429
  >,
>(
  params: DashboardTournamentsControllerCalendarParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardTournamentsControllerCalendarQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>
  > = ({ signal }) => dashboardTournamentsControllerCalendar(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentsControllerCalendarQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>
>;
export type DashboardTournamentsControllerCalendarQueryError = ErrorType<
  | DashboardTournamentsControllerCalendar400
  | DashboardTournamentsControllerCalendar401
  | DashboardTournamentsControllerCalendar429
>;

export function useDashboardTournamentsControllerCalendar<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>,
  TError = ErrorType<
    | DashboardTournamentsControllerCalendar400
    | DashboardTournamentsControllerCalendar401
    | DashboardTournamentsControllerCalendar429
  >,
>(
  params: DashboardTournamentsControllerCalendarParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerCalendar<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>,
  TError = ErrorType<
    | DashboardTournamentsControllerCalendar400
    | DashboardTournamentsControllerCalendar401
    | DashboardTournamentsControllerCalendar429
  >,
>(
  params: DashboardTournamentsControllerCalendarParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerCalendar<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>,
  TError = ErrorType<
    | DashboardTournamentsControllerCalendar400
    | DashboardTournamentsControllerCalendar401
    | DashboardTournamentsControllerCalendar429
  >,
>(
  params: DashboardTournamentsControllerCalendarParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Tournament calendar (dashboard)
 */

export function useDashboardTournamentsControllerCalendar<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>,
  TError = ErrorType<
    | DashboardTournamentsControllerCalendar400
    | DashboardTournamentsControllerCalendar401
    | DashboardTournamentsControllerCalendar429
  >,
>(
  params: DashboardTournamentsControllerCalendarParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerCalendar>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentsControllerCalendarQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Streamed CSV / XLSX export of the full filtered set. Accepts the same filter surface as the list endpoint (including the League Setup season / region / level / custom tag ids). No pagination; capped at 100k rows server-side (413 EXPORT_TOO_LARGE).
 * @summary Export tournaments (dashboard)
 */
export const dashboardTournamentsControllerExport = (
  params: DashboardTournamentsControllerExportParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<Blob>(
    {
      url: `/api/dashboard/v1/tournaments/export`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options
  );
};

export const getDashboardTournamentsControllerExportQueryKey = (
  params: DashboardTournamentsControllerExportParams
) => {
  return [`/api/dashboard/v1/tournaments/export`, ...(params ? [params] : [])] as const;
};

export const getDashboardTournamentsControllerExportQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>,
  TError = ErrorType<
    | DashboardTournamentsControllerExport400
    | DashboardTournamentsControllerExport401
    | DashboardTournamentsControllerExport413
    | DashboardTournamentsControllerExport429
  >,
>(
  params: DashboardTournamentsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardTournamentsControllerExportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>
  > = ({ signal }) => dashboardTournamentsControllerExport(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentsControllerExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>
>;
export type DashboardTournamentsControllerExportQueryError = ErrorType<
  | DashboardTournamentsControllerExport400
  | DashboardTournamentsControllerExport401
  | DashboardTournamentsControllerExport413
  | DashboardTournamentsControllerExport429
>;

export function useDashboardTournamentsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>,
  TError = ErrorType<
    | DashboardTournamentsControllerExport400
    | DashboardTournamentsControllerExport401
    | DashboardTournamentsControllerExport413
    | DashboardTournamentsControllerExport429
  >,
>(
  params: DashboardTournamentsControllerExportParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>,
  TError = ErrorType<
    | DashboardTournamentsControllerExport400
    | DashboardTournamentsControllerExport401
    | DashboardTournamentsControllerExport413
    | DashboardTournamentsControllerExport429
  >,
>(
  params: DashboardTournamentsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>,
  TError = ErrorType<
    | DashboardTournamentsControllerExport400
    | DashboardTournamentsControllerExport401
    | DashboardTournamentsControllerExport413
    | DashboardTournamentsControllerExport429
  >,
>(
  params: DashboardTournamentsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export tournaments (dashboard)
 */

export function useDashboardTournamentsControllerExport<
  TData = Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>,
  TError = ErrorType<
    | DashboardTournamentsControllerExport400
    | DashboardTournamentsControllerExport401
    | DashboardTournamentsControllerExport413
    | DashboardTournamentsControllerExport429
  >,
>(
  params: DashboardTournamentsControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentsControllerExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentsControllerExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Approve / decline / re-queue a tournament. Writes only `approvalStatus` — the orthogonal `status` visibility flag and the date-derived lifecycle bucket are untouched. Re-sending the current value is a no-op (no write, no audit row) so repeated clicks are idempotent. Replaces the legacy GraphQL `updateTournament(approvalStatus)` call.
 * @summary Set tournament approval status (dashboard)
 */
export const dashboardTournamentsControllerUpdateApprovalStatus = (
  id: string,
  dashboardTournamentApprovalUpdate: BodyType<DashboardTournamentApprovalUpdate>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardTournamentApproval>(
    {
      url: `/api/dashboard/v1/tournaments/${id}/approval-status`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardTournamentApprovalUpdate,
    },
    options
  );
};

export const getDashboardTournamentsControllerUpdateApprovalStatusMutationOptions = <
  TError = ErrorType<
    | DashboardTournamentsControllerUpdateApprovalStatus400
    | DashboardTournamentsControllerUpdateApprovalStatus401
    | DashboardTournamentsControllerUpdateApprovalStatus404
    | DashboardTournamentsControllerUpdateApprovalStatus429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerUpdateApprovalStatus>>,
    TError,
    { id: string; data: BodyType<DashboardTournamentApprovalUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTournamentsControllerUpdateApprovalStatus>>,
  TError,
  { id: string; data: BodyType<DashboardTournamentApprovalUpdate> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTournamentsControllerUpdateApprovalStatus>>,
    { id: string; data: BodyType<DashboardTournamentApprovalUpdate> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardTournamentsControllerUpdateApprovalStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTournamentsControllerUpdateApprovalStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentsControllerUpdateApprovalStatus>>
>;
export type DashboardTournamentsControllerUpdateApprovalStatusMutationBody =
  BodyType<DashboardTournamentApprovalUpdate>;
export type DashboardTournamentsControllerUpdateApprovalStatusMutationError = ErrorType<
  | DashboardTournamentsControllerUpdateApprovalStatus400
  | DashboardTournamentsControllerUpdateApprovalStatus401
  | DashboardTournamentsControllerUpdateApprovalStatus404
  | DashboardTournamentsControllerUpdateApprovalStatus429
>;

/**
 * @summary Set tournament approval status (dashboard)
 */
export const useDashboardTournamentsControllerUpdateApprovalStatus = <
  TError = ErrorType<
    | DashboardTournamentsControllerUpdateApprovalStatus400
    | DashboardTournamentsControllerUpdateApprovalStatus401
    | DashboardTournamentsControllerUpdateApprovalStatus404
    | DashboardTournamentsControllerUpdateApprovalStatus429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerUpdateApprovalStatus>>,
    TError,
    { id: string; data: BodyType<DashboardTournamentApprovalUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTournamentsControllerUpdateApprovalStatus>>,
  TError,
  { id: string; data: BodyType<DashboardTournamentApprovalUpdate> },
  TContext
> => {
  const mutationOptions =
    getDashboardTournamentsControllerUpdateApprovalStatusMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Create a new tournament from an existing one. Everything is carried over verbatim — categories and their settings, venues, courts, referees, fact sheets, discounts, additional questions, and the league binding — except the title and the four dates, which the caller supplies. Entries, draws, matches, and results are never copied; the copy always starts empty. No organizer / league-manager notifications fire for a copy. Replaces the legacy GraphQL `cloneTournament` mutation.
 * @summary Copy a tournament (dashboard)
 */
export const dashboardTournamentsControllerCopy = (
  id: string,
  dashboardTournamentCopy: BodyType<DashboardTournamentCopy>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentRef>(
    {
      url: `/api/dashboard/v1/tournaments/${id}/copy`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardTournamentCopy,
      signal,
    },
    options
  );
};

export const getDashboardTournamentsControllerCopyMutationOptions = <
  TError = ErrorType<
    | DashboardTournamentsControllerCopy400
    | DashboardTournamentsControllerCopy401
    | DashboardTournamentsControllerCopy404
    | DashboardTournamentsControllerCopy429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerCopy>>,
    TError,
    { id: string; data: BodyType<DashboardTournamentCopy> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTournamentsControllerCopy>>,
  TError,
  { id: string; data: BodyType<DashboardTournamentCopy> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTournamentsControllerCopy>>,
    { id: string; data: BodyType<DashboardTournamentCopy> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardTournamentsControllerCopy(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTournamentsControllerCopyMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentsControllerCopy>>
>;
export type DashboardTournamentsControllerCopyMutationBody = BodyType<DashboardTournamentCopy>;
export type DashboardTournamentsControllerCopyMutationError = ErrorType<
  | DashboardTournamentsControllerCopy400
  | DashboardTournamentsControllerCopy401
  | DashboardTournamentsControllerCopy404
  | DashboardTournamentsControllerCopy429
>;

/**
 * @summary Copy a tournament (dashboard)
 */
export const useDashboardTournamentsControllerCopy = <
  TError = ErrorType<
    | DashboardTournamentsControllerCopy400
    | DashboardTournamentsControllerCopy401
    | DashboardTournamentsControllerCopy404
    | DashboardTournamentsControllerCopy429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerCopy>>,
    TError,
    { id: string; data: BodyType<DashboardTournamentCopy> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTournamentsControllerCopy>>,
  TError,
  { id: string; data: BodyType<DashboardTournamentCopy> },
  TContext
> => {
  const mutationOptions = getDashboardTournamentsControllerCopyMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Soft-delete the tournament (stamps `deletedAt`). Child rows — entries, draws, matches, categories — are left intact so the row stays restorable and the audit trail queryable. Requires the caller's current password in the body as an explicit confirmation gate. Replaces the legacy GraphQL `softDeleteTournament` mutation. Returns 204.
 * @summary Delete a tournament (dashboard)
 */
export const dashboardTournamentsControllerRemove = (
  id: string,
  dashboardDeleteTournament: BodyType<DashboardDeleteTournament>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    {
      url: `/api/dashboard/v1/tournaments/${id}`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: dashboardDeleteTournament,
    },
    options
  );
};

export const getDashboardTournamentsControllerRemoveMutationOptions = <
  TError = ErrorType<
    | DashboardTournamentsControllerRemove400
    | DashboardTournamentsControllerRemove401
    | DashboardTournamentsControllerRemove403
    | DashboardTournamentsControllerRemove404
    | DashboardTournamentsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerRemove>>,
    TError,
    { id: string; data: BodyType<DashboardDeleteTournament> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTournamentsControllerRemove>>,
  TError,
  { id: string; data: BodyType<DashboardDeleteTournament> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTournamentsControllerRemove>>,
    { id: string; data: BodyType<DashboardDeleteTournament> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardTournamentsControllerRemove(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTournamentsControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentsControllerRemove>>
>;
export type DashboardTournamentsControllerRemoveMutationBody = BodyType<DashboardDeleteTournament>;
export type DashboardTournamentsControllerRemoveMutationError = ErrorType<
  | DashboardTournamentsControllerRemove400
  | DashboardTournamentsControllerRemove401
  | DashboardTournamentsControllerRemove403
  | DashboardTournamentsControllerRemove404
  | DashboardTournamentsControllerRemove429
>;

/**
 * @summary Delete a tournament (dashboard)
 */
export const useDashboardTournamentsControllerRemove = <
  TError = ErrorType<
    | DashboardTournamentsControllerRemove400
    | DashboardTournamentsControllerRemove401
    | DashboardTournamentsControllerRemove403
    | DashboardTournamentsControllerRemove404
    | DashboardTournamentsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentsControllerRemove>>,
    TError,
    { id: string; data: BodyType<DashboardDeleteTournament> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTournamentsControllerRemove>>,
  TError,
  { id: string; data: BodyType<DashboardDeleteTournament> },
  TContext
> => {
  const mutationOptions = getDashboardTournamentsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Paginated list of the category GROUPS belonging to a single league — the data source for the league edit page's category-groups tab. Each row carries the numeric group `id`, `name` and `categoriesCount`. The group's categories are NOT embedded (a group can hold hundreds): fetch them from the paginated sub-resource `GET /tournament-category-groups/{id}/categories` when the accordion row expands. `leagueId` (`lge_…`) is required and access-checked up front: a caller who cannot reach that league gets a 403 (this is an edit-page tab, not a silent picker). Groups are ordered by insertion (`id` ASC).
 * @summary List tournament category groups for a league (dashboard)
 */
export const dashboardTournamentCategoryGroupsControllerList = (
  params: DashboardTournamentCategoryGroupsControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentCategoryGroupList>(
    { url: `/api/dashboard/v1/tournament-category-groups`, method: "GET", params, signal },
    options
  );
};

export const getDashboardTournamentCategoryGroupsControllerListQueryKey = (
  params: DashboardTournamentCategoryGroupsControllerListParams
) => {
  return [`/api/dashboard/v1/tournament-category-groups`, ...(params ? [params] : [])] as const;
};

export const getDashboardTournamentCategoryGroupsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerList400
    | DashboardTournamentCategoryGroupsControllerList401
    | DashboardTournamentCategoryGroupsControllerList429
  >,
>(
  params: DashboardTournamentCategoryGroupsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardTournamentCategoryGroupsControllerListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>
  > = ({ signal }) =>
    dashboardTournamentCategoryGroupsControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentCategoryGroupsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>
>;
export type DashboardTournamentCategoryGroupsControllerListQueryError = ErrorType<
  | DashboardTournamentCategoryGroupsControllerList400
  | DashboardTournamentCategoryGroupsControllerList401
  | DashboardTournamentCategoryGroupsControllerList429
>;

export function useDashboardTournamentCategoryGroupsControllerList<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerList400
    | DashboardTournamentCategoryGroupsControllerList401
    | DashboardTournamentCategoryGroupsControllerList429
  >,
>(
  params: DashboardTournamentCategoryGroupsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentCategoryGroupsControllerList<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerList400
    | DashboardTournamentCategoryGroupsControllerList401
    | DashboardTournamentCategoryGroupsControllerList429
  >,
>(
  params: DashboardTournamentCategoryGroupsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentCategoryGroupsControllerList<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerList400
    | DashboardTournamentCategoryGroupsControllerList401
    | DashboardTournamentCategoryGroupsControllerList429
  >,
>(
  params: DashboardTournamentCategoryGroupsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List tournament category groups for a league (dashboard)
 */

export function useDashboardTournamentCategoryGroupsControllerList<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerList400
    | DashboardTournamentCategoryGroupsControllerList401
    | DashboardTournamentCategoryGroupsControllerList429
  >,
>(
  params: DashboardTournamentCategoryGroupsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentCategoryGroupsControllerListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a named group of tournament categories under a league. `leagueId` (`lge_…`) is required and access-checked up front — an out-of-scope league is a genuine 403 (create is not an existence-probe surface, unlike the read/write-by-id endpoints which 404). `categoryIds` must contain at least one `cat_…`; the categories may come from ANY league you can access, not only the group's own league, and an unknown or inaccessible id is a 400 naming the offending ids. Returns the full `DashboardTournamentCategoryGroupDetail` so the FE can prefill without a follow-up read.
 * @summary Create a tournament category group (dashboard)
 */
export const dashboardTournamentCategoryGroupsControllerCreate = (
  dashboardCreateTournamentCategoryGroup: BodyType<DashboardCreateTournamentCategoryGroup>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentCategoryGroupDetail>(
    {
      url: `/api/dashboard/v1/tournament-category-groups`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreateTournamentCategoryGroup,
      signal,
    },
    options
  );
};

export const getDashboardTournamentCategoryGroupsControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerCreate400
    | DashboardTournamentCategoryGroupsControllerCreate401
    | DashboardTournamentCategoryGroupsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateTournamentCategoryGroup> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateTournamentCategoryGroup> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerCreate>>,
    { data: BodyType<DashboardCreateTournamentCategoryGroup> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardTournamentCategoryGroupsControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTournamentCategoryGroupsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerCreate>>
>;
export type DashboardTournamentCategoryGroupsControllerCreateMutationBody =
  BodyType<DashboardCreateTournamentCategoryGroup>;
export type DashboardTournamentCategoryGroupsControllerCreateMutationError = ErrorType<
  | DashboardTournamentCategoryGroupsControllerCreate400
  | DashboardTournamentCategoryGroupsControllerCreate401
  | DashboardTournamentCategoryGroupsControllerCreate429
>;

/**
 * @summary Create a tournament category group (dashboard)
 */
export const useDashboardTournamentCategoryGroupsControllerCreate = <
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerCreate400
    | DashboardTournamentCategoryGroupsControllerCreate401
    | DashboardTournamentCategoryGroupsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateTournamentCategoryGroup> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateTournamentCategoryGroup> },
  TContext
> => {
  const mutationOptions =
    getDashboardTournamentCategoryGroupsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Full `DashboardTournamentCategoryGroupDetail` for the group create/update form — the group name, its league, and the categories it contains. 404 when the group is out of scope so existence is not probable (the access gate remaps a scope miss to not-found, never a 403).
 * @summary Get a tournament category group (dashboard)
 */
export const dashboardTournamentCategoryGroupsControllerDetail = (
  id: number,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentCategoryGroupDetail>(
    { url: `/api/dashboard/v1/tournament-category-groups/${id}`, method: "GET", signal },
    options
  );
};

export const getDashboardTournamentCategoryGroupsControllerDetailQueryKey = (id: number) => {
  return [`/api/dashboard/v1/tournament-category-groups/${id}`] as const;
};

export const getDashboardTournamentCategoryGroupsControllerDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerDetail400
    | DashboardTournamentCategoryGroupsControllerDetail401
    | DashboardTournamentCategoryGroupsControllerDetail404
    | DashboardTournamentCategoryGroupsControllerDetail429
  >,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardTournamentCategoryGroupsControllerDetailQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>
  > = ({ signal }) => dashboardTournamentCategoryGroupsControllerDetail(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentCategoryGroupsControllerDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>
>;
export type DashboardTournamentCategoryGroupsControllerDetailQueryError = ErrorType<
  | DashboardTournamentCategoryGroupsControllerDetail400
  | DashboardTournamentCategoryGroupsControllerDetail401
  | DashboardTournamentCategoryGroupsControllerDetail404
  | DashboardTournamentCategoryGroupsControllerDetail429
>;

export function useDashboardTournamentCategoryGroupsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerDetail400
    | DashboardTournamentCategoryGroupsControllerDetail401
    | DashboardTournamentCategoryGroupsControllerDetail404
    | DashboardTournamentCategoryGroupsControllerDetail429
  >,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentCategoryGroupsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerDetail400
    | DashboardTournamentCategoryGroupsControllerDetail401
    | DashboardTournamentCategoryGroupsControllerDetail404
    | DashboardTournamentCategoryGroupsControllerDetail429
  >,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentCategoryGroupsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerDetail400
    | DashboardTournamentCategoryGroupsControllerDetail401
    | DashboardTournamentCategoryGroupsControllerDetail404
    | DashboardTournamentCategoryGroupsControllerDetail429
  >,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get a tournament category group (dashboard)
 */

export function useDashboardTournamentCategoryGroupsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerDetail400
    | DashboardTournamentCategoryGroupsControllerDetail401
    | DashboardTournamentCategoryGroupsControllerDetail404
    | DashboardTournamentCategoryGroupsControllerDetail429
  >,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentCategoryGroupsControllerDetailQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Rename a group and replace its category set. The owning league is immutable — `leagueId` is not accepted and sending it is a 400. `categoryIds` is a FULL REPLACE (at least one id): categories omitted from the list are unlinked but PRESERVED as categories. The categories may come from ANY league you can access, not only the group's own league — an unknown or inaccessible id is a 400 naming the offending ids. 404 when the group is out of scope so existence isn't probable. Returns the full `DashboardTournamentCategoryGroupDetail`.
 * @summary Update a tournament category group (dashboard)
 */
export const dashboardTournamentCategoryGroupsControllerUpdate = (
  id: number,
  dashboardUpdateTournamentCategoryGroup: BodyType<DashboardUpdateTournamentCategoryGroup>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardTournamentCategoryGroupDetail>(
    {
      url: `/api/dashboard/v1/tournament-category-groups/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdateTournamentCategoryGroup,
    },
    options
  );
};

export const getDashboardTournamentCategoryGroupsControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerUpdate400
    | DashboardTournamentCategoryGroupsControllerUpdate401
    | DashboardTournamentCategoryGroupsControllerUpdate404
    | DashboardTournamentCategoryGroupsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerUpdate>>,
    TError,
    { id: number; data: BodyType<DashboardUpdateTournamentCategoryGroup> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerUpdate>>,
  TError,
  { id: number; data: BodyType<DashboardUpdateTournamentCategoryGroup> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerUpdate>>,
    { id: number; data: BodyType<DashboardUpdateTournamentCategoryGroup> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardTournamentCategoryGroupsControllerUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTournamentCategoryGroupsControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerUpdate>>
>;
export type DashboardTournamentCategoryGroupsControllerUpdateMutationBody =
  BodyType<DashboardUpdateTournamentCategoryGroup>;
export type DashboardTournamentCategoryGroupsControllerUpdateMutationError = ErrorType<
  | DashboardTournamentCategoryGroupsControllerUpdate400
  | DashboardTournamentCategoryGroupsControllerUpdate401
  | DashboardTournamentCategoryGroupsControllerUpdate404
  | DashboardTournamentCategoryGroupsControllerUpdate429
>;

/**
 * @summary Update a tournament category group (dashboard)
 */
export const useDashboardTournamentCategoryGroupsControllerUpdate = <
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerUpdate400
    | DashboardTournamentCategoryGroupsControllerUpdate401
    | DashboardTournamentCategoryGroupsControllerUpdate404
    | DashboardTournamentCategoryGroupsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerUpdate>>,
    TError,
    { id: number; data: BodyType<DashboardUpdateTournamentCategoryGroup> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerUpdate>>,
  TError,
  { id: number; data: BodyType<DashboardUpdateTournamentCategoryGroup> },
  TContext
> => {
  const mutationOptions =
    getDashboardTournamentCategoryGroupsControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Remove a category group. UNLINK-ONLY: the group and its category links are removed, but the tournament categories themselves are PRESERVED (unlike the legacy GraphQL delete, which cascade-deletes the categories). 404 when the group is out of scope so existence is not probable (the IDOR gate remaps a scope miss to not-found, never a 403).
 * @summary Delete a tournament category group (dashboard)
 */
export const dashboardTournamentCategoryGroupsControllerRemove = (
  id: number,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    { url: `/api/dashboard/v1/tournament-category-groups/${id}`, method: "DELETE" },
    options
  );
};

export const getDashboardTournamentCategoryGroupsControllerRemoveMutationOptions = <
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerRemove400
    | DashboardTournamentCategoryGroupsControllerRemove401
    | DashboardTournamentCategoryGroupsControllerRemove404
    | DashboardTournamentCategoryGroupsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerRemove>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerRemove>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerRemove>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return dashboardTournamentCategoryGroupsControllerRemove(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTournamentCategoryGroupsControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerRemove>>
>;

export type DashboardTournamentCategoryGroupsControllerRemoveMutationError = ErrorType<
  | DashboardTournamentCategoryGroupsControllerRemove400
  | DashboardTournamentCategoryGroupsControllerRemove401
  | DashboardTournamentCategoryGroupsControllerRemove404
  | DashboardTournamentCategoryGroupsControllerRemove429
>;

/**
 * @summary Delete a tournament category group (dashboard)
 */
export const useDashboardTournamentCategoryGroupsControllerRemove = <
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerRemove400
    | DashboardTournamentCategoryGroupsControllerRemove401
    | DashboardTournamentCategoryGroupsControllerRemove404
    | DashboardTournamentCategoryGroupsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerRemove>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerRemove>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getDashboardTournamentCategoryGroupsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Paginated categories of ONE category group — the data source for the expanded accordion body on the league edit page's category-groups tab. Rows use the SHARED `DashboardTournamentCategoryListItem` shape (`id` — the category `cat_…` publicId, `title`, `type`, `gender`, `eventsCount`, `status`) and the SAME ordering as the standalone categories list (`name ASC, id ASC`), so the FE reuses one row renderer. `leagueId` (`lge_…`) is required: the caller is access-checked against that league up front (403 when they cannot reach it), and the group must belong to it — a group from another league is a 404, so existence is never probable. `keyword` is a case-insensitive substring match on the category name. `eventsCount` is the number of distinct tournaments each category is used in, batched across the whole page.
 * @summary List a category group's tournament categories (dashboard)
 */
export const dashboardTournamentCategoryGroupsControllerListCategories = (
  id: number,
  params: DashboardTournamentCategoryGroupsControllerListCategoriesParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentCategoryList>(
    {
      url: `/api/dashboard/v1/tournament-category-groups/${id}/categories`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getDashboardTournamentCategoryGroupsControllerListCategoriesQueryKey = (
  id: number,
  params: DashboardTournamentCategoryGroupsControllerListCategoriesParams
) => {
  return [
    `/api/dashboard/v1/tournament-category-groups/${id}/categories`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDashboardTournamentCategoryGroupsControllerListCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerListCategories400
    | DashboardTournamentCategoryGroupsControllerListCategories401
    | DashboardTournamentCategoryGroupsControllerListCategories403
    | DashboardTournamentCategoryGroupsControllerListCategories404
    | DashboardTournamentCategoryGroupsControllerListCategories429
  >,
>(
  id: number,
  params: DashboardTournamentCategoryGroupsControllerListCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDashboardTournamentCategoryGroupsControllerListCategoriesQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>
  > = ({ signal }) =>
    dashboardTournamentCategoryGroupsControllerListCategories(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentCategoryGroupsControllerListCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>
>;
export type DashboardTournamentCategoryGroupsControllerListCategoriesQueryError = ErrorType<
  | DashboardTournamentCategoryGroupsControllerListCategories400
  | DashboardTournamentCategoryGroupsControllerListCategories401
  | DashboardTournamentCategoryGroupsControllerListCategories403
  | DashboardTournamentCategoryGroupsControllerListCategories404
  | DashboardTournamentCategoryGroupsControllerListCategories429
>;

export function useDashboardTournamentCategoryGroupsControllerListCategories<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerListCategories400
    | DashboardTournamentCategoryGroupsControllerListCategories401
    | DashboardTournamentCategoryGroupsControllerListCategories403
    | DashboardTournamentCategoryGroupsControllerListCategories404
    | DashboardTournamentCategoryGroupsControllerListCategories429
  >,
>(
  id: number,
  params: DashboardTournamentCategoryGroupsControllerListCategoriesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentCategoryGroupsControllerListCategories<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerListCategories400
    | DashboardTournamentCategoryGroupsControllerListCategories401
    | DashboardTournamentCategoryGroupsControllerListCategories403
    | DashboardTournamentCategoryGroupsControllerListCategories404
    | DashboardTournamentCategoryGroupsControllerListCategories429
  >,
>(
  id: number,
  params: DashboardTournamentCategoryGroupsControllerListCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentCategoryGroupsControllerListCategories<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerListCategories400
    | DashboardTournamentCategoryGroupsControllerListCategories401
    | DashboardTournamentCategoryGroupsControllerListCategories403
    | DashboardTournamentCategoryGroupsControllerListCategories404
    | DashboardTournamentCategoryGroupsControllerListCategories429
  >,
>(
  id: number,
  params: DashboardTournamentCategoryGroupsControllerListCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List a category group's tournament categories (dashboard)
 */

export function useDashboardTournamentCategoryGroupsControllerListCategories<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>,
  TError = ErrorType<
    | DashboardTournamentCategoryGroupsControllerListCategories400
    | DashboardTournamentCategoryGroupsControllerListCategories401
    | DashboardTournamentCategoryGroupsControllerListCategories403
    | DashboardTournamentCategoryGroupsControllerListCategories404
    | DashboardTournamentCategoryGroupsControllerListCategories429
  >,
>(
  id: number,
  params: DashboardTournamentCategoryGroupsControllerListCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoryGroupsControllerListCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentCategoryGroupsControllerListCategoriesQueryOptions(
    id,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Paginated list of the categories belonging to a single league — the data source for the league edit page's Categories tab and the shared tournament-categories picker. Returns the full `DashboardTournamentCategoryListItem` shape (`id` — the category `cat_…` publicId, `title`, `type`, `gender`, `eventsCount`, `status`). `leagueId` (`lge_…`) is required and is access-checked up front: a caller who cannot reach that league gets a 403 (this is an edit-page tab, not a silent picker). Optional `types` narrows to one or more competition formats (`single` / `doubles` / `team`). The league edit page's filters popover adds `genders`, `status`, and an `eventsFrom`/`eventsTo` count range optionally bounded by `eventsPeriodFrom`/`eventsPeriodTo`; the same window bounds the returned `eventsCount`, so the number a row shows is the number it was filtered on. `eventsCount` is the number of distinct tournaments each category is used in. Rows come back in the league's MANUAL order (`sortingPosition`, nulls last, then name then id) — the order persisted by `PATCH /reorder`; supplying a `keyword` switches to relevance ordering instead.
 * @summary List tournament categories for a league (dashboard)
 */
export const dashboardTournamentCategoriesControllerList = (
  params: DashboardTournamentCategoriesControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentCategoryList>(
    { url: `/api/dashboard/v1/tournaments/categories`, method: "GET", params, signal },
    options
  );
};

export const getDashboardTournamentCategoriesControllerListQueryKey = (
  params: DashboardTournamentCategoriesControllerListParams
) => {
  return [`/api/dashboard/v1/tournaments/categories`, ...(params ? [params] : [])] as const;
};

export const getDashboardTournamentCategoriesControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerList400
    | DashboardTournamentCategoriesControllerList401
    | DashboardTournamentCategoriesControllerList429
  >,
>(
  params: DashboardTournamentCategoriesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardTournamentCategoriesControllerListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>
  > = ({ signal }) => dashboardTournamentCategoriesControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentCategoriesControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>
>;
export type DashboardTournamentCategoriesControllerListQueryError = ErrorType<
  | DashboardTournamentCategoriesControllerList400
  | DashboardTournamentCategoriesControllerList401
  | DashboardTournamentCategoriesControllerList429
>;

export function useDashboardTournamentCategoriesControllerList<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerList400
    | DashboardTournamentCategoriesControllerList401
    | DashboardTournamentCategoriesControllerList429
  >,
>(
  params: DashboardTournamentCategoriesControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentCategoriesControllerList<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerList400
    | DashboardTournamentCategoriesControllerList401
    | DashboardTournamentCategoriesControllerList429
  >,
>(
  params: DashboardTournamentCategoriesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentCategoriesControllerList<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerList400
    | DashboardTournamentCategoriesControllerList401
    | DashboardTournamentCategoriesControllerList429
  >,
>(
  params: DashboardTournamentCategoriesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List tournament categories for a league (dashboard)
 */

export function useDashboardTournamentCategoriesControllerList<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerList400
    | DashboardTournamentCategoriesControllerList401
    | DashboardTournamentCategoriesControllerList429
  >,
>(
  params: DashboardTournamentCategoriesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentCategoriesControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a category and attach it to a league. `leagueId` (`lge_…`) is the only required relation and is access-checked up front — an out-of-scope league is a genuine 403 (create is not an existence-probe surface, unlike the read/write-by-id endpoints which 404). The category attaches to the league via the `league_tournament_category` join (there is no owning-league column). Returns the full `DashboardTournamentCategoryDetail` so the FE can prefill without a follow-up read.
 * @summary Create a tournament category (dashboard)
 */
export const dashboardTournamentCategoriesControllerCreate = (
  dashboardCreateTournamentCategory: BodyType<DashboardCreateTournamentCategory>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentCategoryDetail>(
    {
      url: `/api/dashboard/v1/tournaments/categories`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreateTournamentCategory,
      signal,
    },
    options
  );
};

export const getDashboardTournamentCategoriesControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerCreate400
    | DashboardTournamentCategoriesControllerCreate401
    | DashboardTournamentCategoriesControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateTournamentCategory> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateTournamentCategory> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerCreate>>,
    { data: BodyType<DashboardCreateTournamentCategory> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardTournamentCategoriesControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTournamentCategoriesControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerCreate>>
>;
export type DashboardTournamentCategoriesControllerCreateMutationBody =
  BodyType<DashboardCreateTournamentCategory>;
export type DashboardTournamentCategoriesControllerCreateMutationError = ErrorType<
  | DashboardTournamentCategoriesControllerCreate400
  | DashboardTournamentCategoriesControllerCreate401
  | DashboardTournamentCategoriesControllerCreate429
>;

/**
 * @summary Create a tournament category (dashboard)
 */
export const useDashboardTournamentCategoriesControllerCreate = <
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerCreate400
    | DashboardTournamentCategoriesControllerCreate401
    | DashboardTournamentCategoriesControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateTournamentCategory> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateTournamentCategory> },
  TContext
> => {
  const mutationOptions = getDashboardTournamentCategoriesControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Paginated cascading category picker. Returns the slim `DashboardTournamentCategoryRef` shape (`id`, `name`). Optional `sportId` / `tournamentId` narrow the result set. Filters intersect with the caller's accessible league set — categories belonging to leagues the caller cannot reach are silently dropped (the endpoint cannot be used to enumerate out-of-scope categories).
 * @summary Search tournament categories (dashboard)
 */
export const dashboardTournamentCategoriesControllerSearch = (
  params?: DashboardTournamentCategoriesControllerSearchParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentCategorySearch>(
    { url: `/api/dashboard/v1/tournaments/categories/search`, method: "GET", params, signal },
    options
  );
};

export const getDashboardTournamentCategoriesControllerSearchQueryKey = (
  params?: DashboardTournamentCategoriesControllerSearchParams
) => {
  return [`/api/dashboard/v1/tournaments/categories/search`, ...(params ? [params] : [])] as const;
};

export const getDashboardTournamentCategoriesControllerSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerSearch400
    | DashboardTournamentCategoriesControllerSearch401
    | DashboardTournamentCategoriesControllerSearch429
  >,
>(
  params?: DashboardTournamentCategoriesControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardTournamentCategoriesControllerSearchQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>
  > = ({ signal }) => dashboardTournamentCategoriesControllerSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentCategoriesControllerSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>
>;
export type DashboardTournamentCategoriesControllerSearchQueryError = ErrorType<
  | DashboardTournamentCategoriesControllerSearch400
  | DashboardTournamentCategoriesControllerSearch401
  | DashboardTournamentCategoriesControllerSearch429
>;

export function useDashboardTournamentCategoriesControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerSearch400
    | DashboardTournamentCategoriesControllerSearch401
    | DashboardTournamentCategoriesControllerSearch429
  >,
>(
  params: undefined | DashboardTournamentCategoriesControllerSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentCategoriesControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerSearch400
    | DashboardTournamentCategoriesControllerSearch401
    | DashboardTournamentCategoriesControllerSearch429
  >,
>(
  params?: DashboardTournamentCategoriesControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentCategoriesControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerSearch400
    | DashboardTournamentCategoriesControllerSearch401
    | DashboardTournamentCategoriesControllerSearch429
  >,
>(
  params?: DashboardTournamentCategoriesControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search tournament categories (dashboard)
 */

export function useDashboardTournamentCategoriesControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerSearch400
    | DashboardTournamentCategoriesControllerSearch401
    | DashboardTournamentCategoriesControllerSearch429
  >,
>(
  params?: DashboardTournamentCategoriesControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentCategoriesControllerSearchQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Batch lookup of the slim `DashboardTournamentCategoryRef` shape for a known set of category public ids (`cat_…`). Used to rehydrate filter-chip labels from saved client state. Order matches the request; ids the caller cannot resolve (missing or out-of-scope) are silently omitted.
 * @summary Resolve tournament-category refs by public id (dashboard)
 */
export const dashboardTournamentCategoriesControllerRefs = (
  params: DashboardTournamentCategoriesControllerRefsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentCategoryRef[]>(
    { url: `/api/dashboard/v1/tournaments/categories/refs`, method: "GET", params, signal },
    options
  );
};

export const getDashboardTournamentCategoriesControllerRefsQueryKey = (
  params: DashboardTournamentCategoriesControllerRefsParams
) => {
  return [`/api/dashboard/v1/tournaments/categories/refs`, ...(params ? [params] : [])] as const;
};

export const getDashboardTournamentCategoriesControllerRefsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerRefs400
    | DashboardTournamentCategoriesControllerRefs401
    | DashboardTournamentCategoriesControllerRefs429
  >,
>(
  params: DashboardTournamentCategoriesControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardTournamentCategoriesControllerRefsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>
  > = ({ signal }) => dashboardTournamentCategoriesControllerRefs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentCategoriesControllerRefsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>
>;
export type DashboardTournamentCategoriesControllerRefsQueryError = ErrorType<
  | DashboardTournamentCategoriesControllerRefs400
  | DashboardTournamentCategoriesControllerRefs401
  | DashboardTournamentCategoriesControllerRefs429
>;

export function useDashboardTournamentCategoriesControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerRefs400
    | DashboardTournamentCategoriesControllerRefs401
    | DashboardTournamentCategoriesControllerRefs429
  >,
>(
  params: DashboardTournamentCategoriesControllerRefsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentCategoriesControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerRefs400
    | DashboardTournamentCategoriesControllerRefs401
    | DashboardTournamentCategoriesControllerRefs429
  >,
>(
  params: DashboardTournamentCategoriesControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentCategoriesControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerRefs400
    | DashboardTournamentCategoriesControllerRefs401
    | DashboardTournamentCategoriesControllerRefs429
  >,
>(
  params: DashboardTournamentCategoriesControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Resolve tournament-category refs by public id (dashboard)
 */

export function useDashboardTournamentCategoriesControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerRefs400
    | DashboardTournamentCategoriesControllerRefs401
    | DashboardTournamentCategoriesControllerRefs429
  >,
>(
  params: DashboardTournamentCategoriesControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRefs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentCategoriesControllerRefsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Persist the drag-and-drop order of a league's categories. `ids` (`cat_…`) is the ordered set of the rows the user dragged among — a SUBSET is fine (the Categories tab is paginated, so the client only holds one page): the supplied categories are permuted across the ordinal slots they already occupy in the league's full manual order, and untouched rows never move. The order is stored in `sortingPosition` and is what `GET /tournaments/categories` returns when no `keyword` is set (a keyword search stays relevance-ordered, so the FE disables dragging while searching). `leagueId` (`lge_…`) is access-checked up front — an out-of-scope league is a genuine 403; an id that does not belong to that league is a 400.
 * @summary Reorder tournament categories (dashboard)
 */
export const dashboardTournamentCategoriesControllerReorder = (
  dashboardReorderTournamentCategories: BodyType<DashboardReorderTournamentCategories>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    {
      url: `/api/dashboard/v1/tournaments/categories/reorder`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardReorderTournamentCategories,
    },
    options
  );
};

export const getDashboardTournamentCategoriesControllerReorderMutationOptions = <
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerReorder400
    | DashboardTournamentCategoriesControllerReorder401
    | DashboardTournamentCategoriesControllerReorder429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerReorder>>,
    TError,
    { data: BodyType<DashboardReorderTournamentCategories> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerReorder>>,
  TError,
  { data: BodyType<DashboardReorderTournamentCategories> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerReorder>>,
    { data: BodyType<DashboardReorderTournamentCategories> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardTournamentCategoriesControllerReorder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTournamentCategoriesControllerReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerReorder>>
>;
export type DashboardTournamentCategoriesControllerReorderMutationBody =
  BodyType<DashboardReorderTournamentCategories>;
export type DashboardTournamentCategoriesControllerReorderMutationError = ErrorType<
  | DashboardTournamentCategoriesControllerReorder400
  | DashboardTournamentCategoriesControllerReorder401
  | DashboardTournamentCategoriesControllerReorder429
>;

/**
 * @summary Reorder tournament categories (dashboard)
 */
export const useDashboardTournamentCategoriesControllerReorder = <
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerReorder400
    | DashboardTournamentCategoriesControllerReorder401
    | DashboardTournamentCategoriesControllerReorder429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerReorder>>,
    TError,
    { data: BodyType<DashboardReorderTournamentCategories> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerReorder>>,
  TError,
  { data: BodyType<DashboardReorderTournamentCategories> },
  TContext
> => {
  const mutationOptions = getDashboardTournamentCategoriesControllerReorderMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Full `DashboardTournamentCategoryDetail` for the create/update form. 404 when the category is out of scope so existence is not probable (the IDOR gate remaps a scope miss to not-found, never a 403).
 * @summary Get a tournament category (dashboard)
 */
export const dashboardTournamentCategoriesControllerDetail = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentCategoryDetail>(
    { url: `/api/dashboard/v1/tournaments/categories/${id}`, method: "GET", signal },
    options
  );
};

export const getDashboardTournamentCategoriesControllerDetailQueryKey = (id: string) => {
  return [`/api/dashboard/v1/tournaments/categories/${id}`] as const;
};

export const getDashboardTournamentCategoriesControllerDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerDetail400
    | DashboardTournamentCategoriesControllerDetail401
    | DashboardTournamentCategoriesControllerDetail404
    | DashboardTournamentCategoriesControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardTournamentCategoriesControllerDetailQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>
  > = ({ signal }) => dashboardTournamentCategoriesControllerDetail(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardTournamentCategoriesControllerDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>
>;
export type DashboardTournamentCategoriesControllerDetailQueryError = ErrorType<
  | DashboardTournamentCategoriesControllerDetail400
  | DashboardTournamentCategoriesControllerDetail401
  | DashboardTournamentCategoriesControllerDetail404
  | DashboardTournamentCategoriesControllerDetail429
>;

export function useDashboardTournamentCategoriesControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerDetail400
    | DashboardTournamentCategoriesControllerDetail401
    | DashboardTournamentCategoriesControllerDetail404
    | DashboardTournamentCategoriesControllerDetail429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentCategoriesControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerDetail400
    | DashboardTournamentCategoriesControllerDetail401
    | DashboardTournamentCategoriesControllerDetail404
    | DashboardTournamentCategoriesControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardTournamentCategoriesControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerDetail400
    | DashboardTournamentCategoriesControllerDetail401
    | DashboardTournamentCategoriesControllerDetail404
    | DashboardTournamentCategoriesControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get a tournament category (dashboard)
 */

export function useDashboardTournamentCategoriesControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>,
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerDetail400
    | DashboardTournamentCategoriesControllerDetail401
    | DashboardTournamentCategoriesControllerDetail404
    | DashboardTournamentCategoriesControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardTournamentCategoriesControllerDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Partial update of a single category — accepts the full editable field set (the create body minus `leagueId`). Presence-preserving: absent keys are left untouched, an explicit `null` clears the column. Changing `type` (`single | doubles | team`) is rejected with a 409 when the category already has registrations. 404 when the category is out of scope so existence isn't probable. Returns the full `DashboardTournamentCategoryDetail`.
 * @summary Update a tournament category (dashboard)
 */
export const dashboardTournamentCategoriesControllerUpdate = (
  id: string,
  dashboardUpdateTournamentCategory: BodyType<DashboardUpdateTournamentCategory>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardTournamentCategoryDetail>(
    {
      url: `/api/dashboard/v1/tournaments/categories/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdateTournamentCategory,
    },
    options
  );
};

export const getDashboardTournamentCategoriesControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerUpdate400
    | DashboardTournamentCategoriesControllerUpdate401
    | DashboardTournamentCategoriesControllerUpdate404
    | DashboardTournamentCategoriesControllerUpdate409
    | DashboardTournamentCategoriesControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdateTournamentCategory> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdateTournamentCategory> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerUpdate>>,
    { id: string; data: BodyType<DashboardUpdateTournamentCategory> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardTournamentCategoriesControllerUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTournamentCategoriesControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerUpdate>>
>;
export type DashboardTournamentCategoriesControllerUpdateMutationBody =
  BodyType<DashboardUpdateTournamentCategory>;
export type DashboardTournamentCategoriesControllerUpdateMutationError = ErrorType<
  | DashboardTournamentCategoriesControllerUpdate400
  | DashboardTournamentCategoriesControllerUpdate401
  | DashboardTournamentCategoriesControllerUpdate404
  | DashboardTournamentCategoriesControllerUpdate409
  | DashboardTournamentCategoriesControllerUpdate429
>;

/**
 * @summary Update a tournament category (dashboard)
 */
export const useDashboardTournamentCategoriesControllerUpdate = <
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerUpdate400
    | DashboardTournamentCategoriesControllerUpdate401
    | DashboardTournamentCategoriesControllerUpdate404
    | DashboardTournamentCategoriesControllerUpdate409
    | DashboardTournamentCategoriesControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdateTournamentCategory> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdateTournamentCategory> },
  TContext
> => {
  const mutationOptions = getDashboardTournamentCategoriesControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Remove a category. Fails with 409 CONFLICT when the category still has category-settings, ranking-category links, or payment history — the FE should archive it instead. 404 when the category is out of scope.
 * @summary Delete a tournament category (dashboard)
 */
export const dashboardTournamentCategoriesControllerRemove = (
  id: string,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    { url: `/api/dashboard/v1/tournaments/categories/${id}`, method: "DELETE" },
    options
  );
};

export const getDashboardTournamentCategoriesControllerRemoveMutationOptions = <
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerRemove400
    | DashboardTournamentCategoriesControllerRemove401
    | DashboardTournamentCategoriesControllerRemove404
    | DashboardTournamentCategoriesControllerRemove409
    | DashboardTournamentCategoriesControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRemove>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRemove>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRemove>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return dashboardTournamentCategoriesControllerRemove(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTournamentCategoriesControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRemove>>
>;

export type DashboardTournamentCategoriesControllerRemoveMutationError = ErrorType<
  | DashboardTournamentCategoriesControllerRemove400
  | DashboardTournamentCategoriesControllerRemove401
  | DashboardTournamentCategoriesControllerRemove404
  | DashboardTournamentCategoriesControllerRemove409
  | DashboardTournamentCategoriesControllerRemove429
>;

/**
 * @summary Delete a tournament category (dashboard)
 */
export const useDashboardTournamentCategoriesControllerRemove = <
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerRemove400
    | DashboardTournamentCategoriesControllerRemove401
    | DashboardTournamentCategoriesControllerRemove404
    | DashboardTournamentCategoriesControllerRemove409
    | DashboardTournamentCategoriesControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRemove>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerRemove>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDashboardTournamentCategoriesControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Clone a category in place — into the same league it belongs to. The copy's name is suffixed with ` - copy` and it receives a fresh `cat_…` publicId. Returns the new `DashboardTournamentCategoryListItem` row (`eventsCount` 0 — a fresh copy is used in no tournaments). 404 when the source is out of scope. NOTE: this action is intentionally NOT idempotent — each call creates a distinct copy, so a retry or double-submit yields multiple ` - copy` rows. Clients must guard against double-submit (e.g. disable the button while the request is in flight); the server does not deduplicate.
 * @summary Duplicate a tournament category (dashboard)
 */
export const dashboardTournamentCategoriesControllerDuplicate = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardTournamentCategoryListItem>(
    { url: `/api/dashboard/v1/tournaments/categories/${id}/duplicate`, method: "POST", signal },
    options
  );
};

export const getDashboardTournamentCategoriesControllerDuplicateMutationOptions = <
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerDuplicate400
    | DashboardTournamentCategoriesControllerDuplicate401
    | DashboardTournamentCategoriesControllerDuplicate404
    | DashboardTournamentCategoriesControllerDuplicate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDuplicate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDuplicate>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDuplicate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return dashboardTournamentCategoriesControllerDuplicate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardTournamentCategoriesControllerDuplicateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDuplicate>>
>;

export type DashboardTournamentCategoriesControllerDuplicateMutationError = ErrorType<
  | DashboardTournamentCategoriesControllerDuplicate400
  | DashboardTournamentCategoriesControllerDuplicate401
  | DashboardTournamentCategoriesControllerDuplicate404
  | DashboardTournamentCategoriesControllerDuplicate429
>;

/**
 * @summary Duplicate a tournament category (dashboard)
 */
export const useDashboardTournamentCategoriesControllerDuplicate = <
  TError = ErrorType<
    | DashboardTournamentCategoriesControllerDuplicate400
    | DashboardTournamentCategoriesControllerDuplicate401
    | DashboardTournamentCategoriesControllerDuplicate404
    | DashboardTournamentCategoriesControllerDuplicate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDuplicate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardTournamentCategoriesControllerDuplicate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions =
    getDashboardTournamentCategoriesControllerDuplicateMutationOptions(options);

  return useMutation(mutationOptions);
};
